import $ from 'jquery';

// Delegation also covers fields inserted after page load and Select2 reinitialization.
$(document).on('select2:open.tangramAll', 'select[multiple]', function () {
  const select = this;
  const $select = $(select);
  const instance = $select.data('select2');
  if (!instance) return;
  const limited = () => Number(instance.options.get('maximumSelectionLength')) > 0 ||
    Number(select.dataset.maxSelectable) > 0 || Number(select.dataset.maximumSelectionLength) > 0;
  const $dropdown = instance.$dropdown;
  $dropdown.find('.tg-multiselect-all').remove();
  if (select.disabled || limited()) return;

  const $button = $('<button type="button" class="tg-multiselect-all select2-results__option select2-results__option--selectable">All</button>')
    .attr('aria-label', 'Select all options');
  // Attach inside the bordered dropdown, not its outer positioning container.
  // Keep it outside the results list, which Select2 replaces on each search.
  $dropdown.find('.select2-results').before($button);
  $button.on('mouseenter focus', () => $button.addClass('select2-results__option--highlighted'));
  $button.on('mouseleave blur', () => $button.removeClass('select2-results__option--highlighted'));
  // Keep Select2's outside-click handler from closing before the action runs.
  $button.on('mousedown', event => event.stopPropagation());
  $button.on('click', async function (event) {
    event.preventDefault();
    if (select.disabled || limited()) return;
    $button.prop('disabled', true).text('Selecting…');
    try {
      let items;
      if (instance.options.get('ajax')) {
        items = await loadAll(instance, $select);
      } else {
        items = Array.from(select.options).map(option => ({
          id: option.value, text: option.text,
          disabled: option.disabled || (option.parentElement.tagName === 'OPTGROUP' && option.parentElement.disabled)
        }));
      }
      if (!select.isConnected || $select.data('select2') !== instance || select.disabled || limited()) return;
      const values = new Set($select.val() || []);
      items.forEach(item => {
        if (!selectable(item)) return;
        const id = String(item.id);
        if (!Array.from(select.options).some(option => option.value === id)) {
          // Preserve remote metadata used by custom selection renderers.
          instance.dataAdapter.addOptions(instance.dataAdapter.option(item));
        }
        values.add(id);
      });
      $select.val(Array.from(values)).trigger('change');
      $select.select2('close');
    } catch (error) {
      // Never apply a partial remote list if a later page fails.
      $button.prop('disabled', false).text('Retry selecting all').attr('aria-label', 'Could not load all options. Retry selecting all');
    }
  });
});

function selectable(item) {
  return item && !item.disabled && item.id != null && String(item.id) !== '' &&
    !['other', '__other_trigger__'].includes(String(item.id));
}

function flatten(items, parentDisabled = false) {
  return (items || []).flatMap(item => item.children ? flatten(item.children, parentDisabled || item.disabled) :
    [{ ...item, disabled: parentDisabled || item.disabled }]);
}

async function loadAll(instance, $select) {
  // Use the adapter's configured transport, request data and result mapping so
  // organization/resource restrictions remain identical to ordinary searches.
  const adapter = instance.dataAdapter;
  const ajax = adapter.ajaxOptions;
  const items = [];
  const seen = new Set();
  for (let page = 1; page <= 1000; page += 1) {
    const params = { term: '', page, _type: page === 1 ? 'query' : 'query_append' };
    const request = { ...ajax };
    if (typeof request.url === 'function') request.url = request.url.call($select, params);
    if (typeof request.data === 'function') request.data = request.data.call($select, params);
    const raw = await new Promise((resolve, reject) => request.transport(request, resolve, reject));
    const result = adapter.processResults(raw, params);
    if (!result || !Array.isArray(result.results)) throw new Error('Invalid dropdown response');
    const batch = flatten(result.results);
    const fresh = batch.filter(item => item.id != null && !seen.has(String(item.id)));
    fresh.forEach(item => seen.add(String(item.id)));
    items.push(...fresh);
    if (!result.pagination || !result.pagination.more) return items;
    if (!fresh.length) throw new Error('Dropdown pagination did not advance');
  }
  throw new Error('Dropdown pagination exceeded limit');
}
